import React from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {useDispatch} from 'react-redux';
import {t} from '@lingui/core/macro';

import {IMessengerChatAdd} from 'entities/notification';
import {fetchMe} from 'entities/user';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import InputName from 'shared/ui/Input/InputName';
import InputText from 'shared/ui/Input/InputText';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import {validateDescription} from 'features/profile/lib/validateDescription';
import {TypedDispatch} from 'shared/model/types';

type AddResult = Promise<{data?: unknown, error?: unknown}>;

interface IBotChatFormProps {
    add: (_data: IMessengerChatAdd) => AddResult,
    isLoading: boolean,
    onSuccess: () => void,
    onClose: () => void,
}

const BotChatForm: React.FC<IBotChatFormProps> = ({add, isLoading, onSuccess, onClose}) => {
    const {register, handleSubmit, formState, control, watch} = useForm<IMessengerChatAdd>({mode: 'onChange'});
    const {errors} = formState;
    const dispatch = useDispatch<TypedDispatch>();

    const tokenValue = watch('token');
    const descriptionValue = watch('description');
    const isFormValid = tokenValue?.trim() && descriptionValue?.trim();

    const onSubmit: SubmitHandler<IMessengerChatAdd> = async(data) => {
        const result = await add({
            token: data.token.trim(),
            description: data.description.trim(),
        });
        if ('error' in result) return;
        dispatch(fetchMe());
        onSuccess();
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <ModalBodyWrapper>
                <FormGroupWithError
                    error={errors?.token?.message}
                    label={t`Токен, полученный от бота`}
                >
                    <InputName
                        control={control}
                        name="token"
                        placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                        register={register}
                        required
                    />
                </FormGroupWithError>

                <FormGroupWithError
                    error={errors?.description?.message}
                    label={t`Описание`}
                >
                    <InputText
                        control={control}
                        name="description"
                        placeholder={t`Краткое описание`}
                        register={register}
                        validate
                        rules={{
                            required: t`Описание обязательно для заполнения`,
                            validate: validateDescription,
                        }}
                    />
                </FormGroupWithError>
            </ModalBodyWrapper>
            <ModalBlockButton
                primaryButtonText={t`Добавить`}
                primaryButtonType="submit"
                primaryButtonLoading={isLoading}
                primaryButtonDisabled={!isFormValid || isLoading}
                secondaryButtonOnClick={onClose}
            />
        </form>
    );
};

export default BotChatForm;
